import { lazyRetry } from '@utils/lazyRetry';
import { layoutConfigOnlyMain } from '@/configs/layoutConfigTemplates';

const ArchiveViewerWindow = lazyRetry(() => import('./ArchiveViewerWindow'));

export default {
  path: 'archive-viewer/:session',
  element: <ArchiveViewerWindow />,
  settings: { layout: layoutConfigOnlyMain }
};
